import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { isOauthConnected } from 'app/modules/meetings/selectors'
import { fetchCalendarStatus } from 'app/modules/meetings/actions'

export default function withOAuthConnectionStatus(WrappedComponent) {
  const enhance = connect(
    (state) => ({ isConnected: isOauthConnected(state) }),
    (dispatch) => ({ actions: bindActionCreators({ fetchCalendarStatus }, dispatch) }),
  )

  class WithOauthConnectionStatus extends Component {
    componentDidMount() {
      this.props.actions.fetchCalendarStatus()
    }

    render() {
      return (
        <WrappedComponent {...this.props}/>
      )
    }
  }

  return enhance(WithOauthConnectionStatus)
}



// WEBPACK FOOTER //
// ./src/scripts/components/settings/UserProfile/Sections/Profile/ContactInfo/withOAuthConnectionStatus.js